export interface AuthInfoProps {
  loggedIn: boolean;
  userId: number;
  identity: Identity;
  accessCode: number;
  expires: number;
}

export interface GlobalContextProps {
  authInfo: AuthInfoProps;
  login: (token: string) => void;
  logout: () => void;
}

export interface AuthRouteProps {
  children: JSX.Element;
  path: string;
  pageAccessCode: AdminAccess;
  exact?: boolean;
}

export interface NavbarAdminItemProps {
  label: string;
  to: string;
  icon: JSX.Element;
  pageAccessCode: AdminAccess;
  showDivider?: boolean;
}

export enum PagePath {
  Index = "/",
  About = "/about",
  Check = "/check",
  Complain = "/complain",
  Lanke = "/lanke",
  Repair = "/repair",
  Suggest = "/suggest",
  Wechat = "/wechat",
  Admin = "/admin"
}

export enum PageLabel {
  Index = "首页",
  About = "关于我们",
  Check = "状态查询",
  Complain = "投诉蓝客",
  Lanke = "蓝客风采",
  Repair = "故障报修",
  Suggest = "意见建议",
  Wechat = "公众号",
  Admin = "后台"
}

export enum Identity {
  None = "none",
  USER = "user",
  LANKE = "lanke",
  LANKE_ADMIN = "lankeAdmin",
  SUPER_ADMIN = "superAdmin",
  ROOT = "root"
}

export enum AdminAccess {
  None = 0,
  Dashboard = 1 << 0,
  ModifyUserInfo = 1 << 1,
  RepairUnreceived = 1 << 2,
  RepairReceived = 1 << 2,
  CommentManagement = 1 << 6,
  Publish = 1 << 3,
  UserManage = 1 << 4,
  ApplyManage = 1 << 5,
  CreditManage = 1 << 6,
  Maintenance = 1 << 7
}
